var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M8 0C3.6 0 0 3.312 0 7.4c0 2.304 1.136 4.36 2.92 5.72L2.968 16l2.76-1.504-.024-.008c.728.2 1.496.312 2.296.312 4.4 0 8-3.312 8-7.4C16 3.312 12.4 0 8 0zm.824 9.928L6.832 7.824 2.8 9.928l4.304-4.504L9.168 7.4l3.88-1.976-4.224 4.504z" })
  );
});